import { getBrowserContext } from '@/lib/browser';
import { queryToJson } from '@/lib/tools';
import 'static/styles/index.scss';
import data from '@/data';
import PreviewDoc from '@/components/player/doc';

let browserContext = getBrowserContext();
console.log('getBrowserContext = ', browserContext);
import $ from 'jquery';

let $main = $('#main');
new PreviewDoc($('.content'), data);



window.addEventListener('message', function(e) {
    let data = e.data || {};
    try{
        if(typeof data === 'string') {
            data = JSON.parse(e.data);
        }
    } catch(err) {
        // 转换出错，意味着上传出错
        console.log('上传出错')
    };
    switch(data.action) {
        case 'uploadSuccess':
            console.log('上传成功，返回结果为 = ', data);
        break; 
    }
}, false);


/*

function windowVisibility() {
    let props = ['hidden', 'webkitHidden', 'mozHidden'];
    let hiddenProperty = null;
    let hiddenTimerId = 0;
    for(let key of props) {
        if(key in document) {
            hiddenProperty = key;
            break;
        }
    }
    let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    let onVisibilityChange = () => {
      
        if(document.visibilityState === 'visible') {
            // 活动状态
            clearTimeout(hiddenTimerId);
            // console.log(`活动状态`);
        } else {
            // 未活动状态, 1分钟后，没有变回活动状态，则停止播放视频
            hiddenTimerId = setTimeout(() => {
                pausePlay(this.play.player);
            }, 1000 * 60);
            // console.log(`未活动状态`);
        }
    };
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
}
*/